import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { ListingPublic } from '../../../../globalTypes/listings.types';
import { shipmentDistanceUnitList, shipmentWeightUnitList, ShippingDistanceUnit, ShippingWeightUnit } from '../../../../globalTypes/fulfillment.types';

@Component({
  selector: 'msh-parcel-units',
  imports: [MatMenuModule],
  template: `
<div class="flex items-center">
  <div class="mr-4">Units:</div>
  <div [matMenuTriggerFor]="readonly ? null : distanceOptions" [class]="(readonly ? 'cursor-default' : 'cursor-pointer hover:bg-copy/15')+' border border-copy/50 rounded-l-lg border-r-0 text-copy px-3 py-1 '">{{parcel.distanceUnit || 'in'}}</div>
  <div [matMenuTriggerFor]="readonly ? null : weightOptions" [class]="(readonly ? 'cursor-default' : 'cursor-pointer hover:bg-copy/15')+' border border-copy/50 rounded-r-lg px-3 py-1 text-copy'">{{parcel.weightUnit || 'lb'}}</div>

  <mat-menu #distanceOptions="matMenu">
    @for(option of shipmentDistanceUnitList; track option){
      <div (click)="updateUnit('distance', option)" mat-menu-item>{{option}}</div>
    }
  </mat-menu>
  <mat-menu #weightOptions="matMenu">
    @for(option of shipmentWeightUnitList; track option){
      <div (click)="updateUnit('weight', option)" mat-menu-item>{{option}}</div>
    }
  </mat-menu>
</div>
  `,
  styles: ``
})
export class ParcelUnitsComponent {
  @Input() readonly = false;
  shipmentWeightUnitList: ShippingWeightUnit[] = shipmentWeightUnitList
  shipmentDistanceUnitList: ShippingDistanceUnit[] = shipmentDistanceUnitList;
  @Input() parcel: ListingPublic | Partial<ListingPublic> = {
    weight: 0,
    height: 0,
    shippingCompressionRate: 0,
    distanceUnit: 'ft',
    length: 0,
    weightUnit: 'lb',
    width: 0,
  }
  @Output() parcelChange: EventEmitter<any> = new EventEmitter();
  @Output() parcelUpdated: EventEmitter<any> = new EventEmitter();


  updateUnit(type:"distance" | "weight", unit: ShippingDistanceUnit | ShippingWeightUnit){
    if(!this.parcel || this.readonly) return;
    if(type === 'distance'){
      this.parcel.distanceUnit = unit as ShippingDistanceUnit;
    } else {
      this.parcel.weightUnit = unit as ShippingWeightUnit;
    }
    this.parcelUpdated.emit();
  }
}
